import { cn } from '@/lib/utils'
import { Tooltip } from '@/components/ui/tooltip'

const PALETTE = ['#0e7c6b', '#4f46e5', '#b45309', '#be185d', '#0369a1', '#4d7c0f', '#7c3aed', '#9f1239', '#c2410c']

function hash(s: string) {
  let h = 0
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) >>> 0
  return h
}

export function UserAvatar({ name, id, size = 'sm', className, withTooltip }: { name: string | null | undefined; id?: string | null; size?: 'xs' | 'sm' | 'md' | 'lg'; className?: string; withTooltip?: boolean }) {
  if (!name) {
    return (
      <span
        className={cn('inline-flex shrink-0 items-center justify-center rounded-full border border-dashed border-border-strong text-fg-subtle', sizeClass(size), className)}
        aria-label="Sem responsável"
        title="Sem responsável"
      />
    )
  }
  const parts = name.trim().split(/\s+/)
  const ini = ((parts[0]?.[0] ?? '') + (parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '')).toUpperCase()
  const avatar = (
    <span
      className={cn('inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-white', sizeClass(size), className)}
      style={{ backgroundColor: PALETTE[hash(id ?? name) % PALETTE.length] }}
      aria-label={name}
      role="img"
    >
      {ini}
    </span>
  )
  return withTooltip ? <Tooltip content={name}>{avatar}</Tooltip> : avatar
}

function sizeClass(size: 'xs' | 'sm' | 'md' | 'lg') {
  return size === 'xs' ? 'size-4 text-[8px]' : size === 'sm' ? 'size-5 text-[9px]' : size === 'md' ? 'size-7 text-[11px]' : 'size-10 text-sm'
}

export function PersonName({ name, id, className }: { name: string | null | undefined; id?: string | null; className?: string }) {
  return (
    <span className={cn('inline-flex min-w-0 items-center gap-1.5', className)}>
      <UserAvatar name={name} id={id} size="sm" />
      <span className={cn('truncate', !name && 'text-fg-subtle')}>{name ?? 'Sem responsável'}</span>
    </span>
  )
}
